import React from "react";
import Heading from "../../Atoms/heading/EventEHRHeading";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import Button from "../button/Button";
import { plusBlueIcon } from "../../../assets";

interface EventEHRCreateOrderCardProps {
  handleClickEvent: () => void;
}

const EventEHRCreateOrderCard = ({
  handleClickEvent,
}: EventEHRCreateOrderCardProps) => {
  return (
    <div className="mt-6">
      <Heading
        title="Order"
        customStyle={{
          fontSize: "16px",
          fontWeight: 500,
          color: "#-",
          marginBottom: "8px",
        }}
      />

      <div
        className="pt-6 pb-6 flex flex-col justify-center items-center gap-4"
        style={{ background: "#F4F4F4", borderRadius: "4px" }}
      >
        <div className="font-weight-500 font-size-18px color-565656">
          {" "}
          {TEXT_CONSTANTS?.NO_ORDER_FOUND}
        </div>
        <Button
          startIcon={<img alt="add icon" src={plusBlueIcon} />}
          variant={"contained"}
          style={{
            background: "#E4F3FF",
            color: "#005596",
            padding: "7px 16px",
          }}
          onClickCb={() => {
            handleClickEvent();
          }}
          label={TEXT_CONSTANTS?.CREATE_ORDER}
        />
      </div>
    </div>
  );
};

export default EventEHRCreateOrderCard;
